import React, { Component } from "react";
import PreviewLinkButton from "./PreviewLinkButton";
import PropTypes from "prop-types";

import connectToDatoCms from "./connectToDatoCms";
import "./style.sass";

@connectToDatoCms(plugin => ({
  developmentMode: plugin.parameters.global.developmentMode,
  fieldValue: plugin.getFieldValue(plugin.fieldPath)
}))
export default class Main extends Component {
  render() {
    const {
      fieldValue: FIELD_VALUE,
      plugin: {
        _settings: {
          fieldPath: FIELD_PATH,
          field: {
            attributes: { label: FIELD_LABEL }
          }
        }
      }
    } = this.props;

    return (
      <div className="container">
        <PreviewLinkButton
          FIELD_PATH={FIELD_PATH}
          FIELD_LABEL={FIELD_LABEL}
          FIELD_VALUE={FIELD_VALUE}
        />
      </div>
    );
  }
}
